const normalize = (value) => String(value || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-zA-Z0-9]/g, "")
  .toUpperCase();

const FR_MONTHS = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"];

export function marketMonthLabels(periodStart, length = 12) {
  const match = String(periodStart || "").match(/^(\d{4})-(0[1-9]|1[0-2])$/);
  if (!match) return FR_MONTHS.slice(0, length);

  const startMonth = Number(match[2]) - 1;
  return Array.from({ length }, (_, index) => FR_MONTHS[(startMonth + index) % 12]);
}

export function marketSeasonalitySeries(selected) {
  if (!Array.isArray(selected?.seasonality) || selected.seasonality.length === 0) return null;
  const values = selected.seasonality.map((value) => Number(value));
  if (!values.some((value) => Number.isFinite(value) && value > 0)) return null;

  const finiteValues = values.filter(Number.isFinite);
  const average = finiteValues.reduce((sum, value) => sum + value, 0) / finiteValues.length;
  if (!average) return null;

  const labels = marketMonthLabels(selected.period_start, values.length);
  return values.map((value, index) => ({
    month: labels[index],
    value: Number.isFinite(value) ? Math.round((value / average) * 100) : 0,
    arrivals: Number.isFinite(value) ? value : null,
  }));
}

export function findRouteMarket(markets = [], routeKey, routeOption) {
  if (!routeKey) return null;
  const exactAir = markets.find((row) => row.air_market_key === routeKey);
  if (exactAir) return exactAir;

  const routeOrigin = String(routeKey).split("-")[0];
  const candidates = [routeOrigin, routeOption?.origin].map(normalize).filter(Boolean);
  return markets.find((row) => {
    const rowValues = [row.iso, row.key, row.name, row.raw].map(normalize).filter(Boolean);
    return candidates.some((candidate) => rowValues.includes(candidate));
  }) || null;
}

export function comparableMarketRank(markets = [], selected) {
  if (!selected) return null;
  const comparable = markets
    .filter((row) => row.volume_metric === selected.volume_metric && Number.isFinite(Number(row.volume)))
    .slice()
    .sort((a, b) => Number(b.volume) - Number(a.volume));
  const index = comparable.findIndex((row) => row.key === selected.key || row.iso === selected.iso);
  return index < 0 ? null : { rank: index + 1, total: comparable.length };
}

export function marketPeriodLabel(selected, fallback) {
  if (selected?.period_start && selected?.period_end) {
    return `${selected.period_start} → ${selected.period_end}`;
  }
  return fallback || "Période indisponible";
}
